import { ReportRequest } from '@/client/reports';
import { CompletionsOverTime } from '@/components/courses/CompletionsOverTime';
import { NeverLoggedInUsers } from '@/components/courses/NeverLoggedInUsers';
import { OverdueUsers } from '@/components/dashboards/admin/OverdueUsers';
import { FlexContainer } from '@/ui/styled-ui';
import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled(FlexContainer)`
  flex-wrap: wrap;

  > div {
    flex: 1 1 400px;
    min-width: 0;
    max-width: 100%;
  }
`;

type AwarenessTrainingProps = {
  filters: ReportRequest;
};

export const AwarenessTraining = ({ filters }: AwarenessTrainingProps) => {
  return (
    <>
      <StyledContainer
        id="awareness-training-container"
        wrap="wrap"
        align="stretch"
        justify="space-between"
        gap="var(--medium-padding)"
        className="mt-3 w-full"
      >
        <OverdueUsers filters={filters} />
        <CompletionsOverTime filters={filters} />
      </StyledContainer>
      <NeverLoggedInUsers />
    </>
  );
};
